var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import TextField from '@mui/material/TextField';
import { styled } from '../styles';
// Define a styled TextField component
export const StyledTextField = styled(TextField, {
    shouldForwardProp: (prop) => !['variant'].includes(prop)
})(({ theme, variant = 'outlined' }) => (Object.assign(Object.assign({ '& .MuiInputBase-root': {
        padding: theme.palette.textField.padding,
        height: '36px',
        backgroundColor: theme.palette.textField.background.default
    }, '& .MuiInputBase-input': {
        padding: 0,
        height: 'inherit',
        fontFamily: theme.palette.textField.font.family,
        fontSize: theme.palette.textField.font.size,
        lineHeight: theme.palette.textField.font.lineHeight,
        fontWeight: theme.palette.textField.font.weight,
        letterSpacing: theme.palette.textField.font.letterSpacing
    }, '& .MuiInputLabel-root': {
        color: theme.palette.textField.label.text.default,
        transform: 'translate(8px, 8px) scale(1)',
        '&.Mui-disabled': {
            color: theme.palette.textField.label.text.disabled
        },
        '&.Mui-error': {
            color: theme.palette.textField.label.text.error
        }
    }, '& .MuiInputLabel-shrink': {
        transform: 'translate(14px, -8px) scale(0.75)'
    }, '& .MuiFormHelperText-root': {
        fontFamily: theme.palette.textField.helpText.font.family,
        fontSize: theme.palette.textField.helpText.font.size,
        fontWeight: theme.palette.textField.helpText.font.weight,
        lineHeight: theme.palette.textField.helpText.font.lineHeight,
        letterSpacing: theme.palette.textField.helpText.font.letterSpacing,
        color: theme.palette.textField.helpText.text.default,
        '&.Mui-disabled': {
            color: theme.palette.textField.helpText.text.disabled
        },
        '&.Mui-error': {
            color: theme.palette.textField.helpText.text.error
        }
    } }, (variant === 'outlined' && {
    '& .MuiOutlinedInput-root': {
        borderRadius: theme.palette.textField.radius,
        '&:hover fieldset': {
            border: `${theme.palette.textField.border.width} solid ${theme.palette.textField.border.hover}`
        },
        '&.Mui-focused fieldset': {
            border: `${theme.palette.textField.border.width} solid ${theme.palette.textField.border.focus}`
        },
        '&.Mui-disabled fieldset': {
            border: `${theme.palette.textField.border.width} solid ${theme.palette.textField.border.disabled}`
        },
        '&.Mui-error fieldset': {
            border: `${theme.palette.textField.border.width} solid ${theme.palette.textField.border.error}`
        }
    }
})), { '& .MuiInputAdornment-positionStart': {
        gap: theme.palette.textField.spaceBetween,
        marginLeft: `-${theme.palette.textField.spaceBetween}`
    }, '& .MuiInputAdornment-positionEnd': {
        gap: theme.palette.textField.spaceBetween
    } })));
const BDSTextField = (_a) => {
    var { helperText, variant } = _a, props = __rest(_a, ["helperText", "variant"]);
    return React.createElement(StyledTextField, Object.assign({}, props, { variant: variant, helperText: helperText }));
};
export default BDSTextField;
//# sourceMappingURL=TextField.js.map